module.exports = __webpack_public_path__ + "img/area4_211021.10c07ba0.jpg";